import "./styles.css";
import React from "react";
import { Modal, Table, Empty, Button, Input, Form, Select } from "antd";
import { FACTURA, BOLETA_DE_VENTA, NOTA_DE_CREDITO, NOTA_DE_DEBITO, GUIA_REMISION_REMITENTE,RETENCION} from '../../../common/types/tipoComprobanteType';
import global from '../../../common/utility/global';
const { Option } = Select;
class SeriesModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      
      console.log(values);
      if (!err) {
        const form = {
          idUsuario: values.idUsuario,
          listaSerieUsuario: this.fetchSeries(values)
        };
        this.props.onSaveSeries(form, this.props.form);
      }
    });
  };

  fetchSeries = (values) => {
    var result = [];

    if (values.arrTipoComprobante === undefined ||
        values.arrSerie === undefined)
        return result;

    var keys = [];
    var obj = Object.assign({}, values.arrTipoComprobante);

    for (var [key, ] of Object.entries(obj)) {
        keys.push(key);
    }

    keys.forEach(key => {
        result.push({
            idUsuario: this.props.formValues.idUsuario,
            idTipoComprobante: values.arrTipoComprobante[key].key,
            serie: values.arrSerie[key].toUpperCase()
        });
    });

    return result;
};

serieCustomValidation = (rule, value, callback) => {
  
  var identifier = rule.field.replace("arrSerie","").replace("[","").replace("]","");
  var item = this.props.formValues.listaSerieUsuario.filter(function (item) {
    return item.identifier === identifier;
  })[0];
  var idTipoComprobante = this.props.form.getFieldValue(`arrTipoComprobante[${identifier}]`).key;

  if (idTipoComprobante === FACTURA.ID) {
      if (value !== undefined && value.length > 0 && value.toUpperCase().substring(0,1) !== "F")
          callback('La serie debe iniciar con "F"');
  }
  else if (idTipoComprobante === BOLETA_DE_VENTA.ID) {
      if (value !== undefined && value.length > 0 && value.toUpperCase().substring(0,1) !== "B")
          callback('La serie debe iniciar con "B"');
  } 
  else if (idTipoComprobante === NOTA_DE_CREDITO.ID || idTipoComprobante === NOTA_DE_DEBITO.ID) {
    if (value !== undefined && value.length > 0 && value.toUpperCase().substring(0,1) !== "B" && value.toUpperCase().substring(0,1) !== "F")
        callback('La serie debe iniciar con "F o B"');
  } 
  
  else if (idTipoComprobante === RETENCION.ID) {
    if (value !== undefined && value.length > 0 && value.toUpperCase().substring(0,1) !== "R")
        callback('La serie debe iniciar con "R"');
} 

  else if (idTipoComprobante === GUIA_REMISION_REMITENTE.ID) {
    if (value !== undefined && value.length > 0 && value.toUpperCase().substring(0,1) !== "T")
        callback('La serie debe iniciar con "T"');
  }
  
  callback();
};

  render() {
    const { getFieldDecorator } = this.props.form;
    getFieldDecorator("idUsuario", {
      initialValue: this.props.formValues.idUsuario,
    });
    return (
      <Modal
        title="Asignar Series"
        visible={this.props.visibleSeries}
        cancelText={"Cancelar"}
        okText={"Guardar"}
        onCancel={this.handleCancel}
        onOk={this.handleOk}
        style={{ top: 30 }}
      >
        <Form>
          <div className="row mb-15">
            <div className="col-md-12">
              <Button
                icon="plus"
                type="primary"
                onClick={() => this.props.onAgregarSerie()}
              >
                Agregar
              </Button>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Table
                style={{ overflowX: "auto" }}
                className={"table-usuario-serie"}
                size="small"
                pagination={false}
                dataSource={this.props.formValues.listaSerieUsuario}
                rowKey={(record) => record.identifier}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description='Pulse el botón "+ Agregar".'
                    />
                  ),
                }}
                columns={[
                  {
                    key: "remove-button",
                    align: "center",
                    width: "50px",
                    render: (value, row) => (
                      <span>
                        <div className="custom-options">
                          <Button
                            type="danger"
                            icon="delete"
                            size={"small"}
                            onClick={() => this.props.onRemoverSerie(value)}
                          />
                        </div>
                      </span>
                    ),
                  },
                  {
                    title: "Tipo Comprobante",
                    dataIndex: "idTipoComprobante",
                    key: "idTipoComprobante",
                    render: (value, row) => {
                      return (
                        <Form.Item>
                          {getFieldDecorator(
                            `arrTipoComprobante[${row.identifier}]`,
                            {
                              initialValue: value ? { key: value } : undefined,
                              validateTrigger: ["onBlur"],
                              rules: [
                                {
                                  required: true,
                                  message: "Requerido",
                                },
                              ],
                            }
                          )(
                            <Select
                              showSearch
                              labelInValue
                              placeholder={"Seleccione Tipo Comprobante"}
                              optionFilterProp="children"
                            >
                              {this.props.tiposComprobante.map((item) => (
                                <Option key={item.id} value={item.id}>
                                  {item.nombre}
                                </Option>
                              ))}
                            </Select>
                          )}
                        </Form.Item>
                      );
                    },
                  },
                  {
                    title: "Serie",
                    dataIndex: "serie",
                    key: "serie",
                    render: (value, row) => {
                      return (
                        <Form.Item>
                          {getFieldDecorator(`arrSerie[${row.identifier}]`, {
                            initialValue: value,
                            validateTrigger: ["onBlur"],
                            rules: [
                              {
                                required: true,
                                message: "Requerido",
                                whitespace: true,
                              },
                              {
                                  validator: this.serieCustomValidation
                              }
                            ]
                          })(
                            <Input
                              onKeyPress={global.onKeyPressTextNumber}
                              maxLength = {4}
                              minLength = {4}
                              placeholder="Ingresar Serie"
                              autoComplete="off"
                            />
                          )}
                        </Form.Item>
                      );
                    },
                  }
                ]}
              />
            </div>
          </div>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(SeriesModal);
